<template>
  <div class="modal-backdrop" tabindex="-1">
    <div class="modal-dialog modal-fullscreen" style="z-index: 999999 !important">
      <div class="modal-content">
        <button type="button" class="modal-close" aria-label="Close" @click="isCancelButtonClicked = true">
          <span aria-hidden="true"><i class="fa fa-times" aria-hidden="true"></i></span>
        </button>
        <div class="modal-header">
          <span>{{ $t("headerSideMenuV1.uploadSeamworksDatabase") }}</span>
        </div>
        <AlertComponent
          v-if="isCancelButtonClicked"
          @setWindow="handleSetWindow"
          :isCancelButtonClicked="isCancelButtonClicked"
          @hidePopup="isCancelButtonClicked = false"
        ></AlertComponent>
        <div class="modal-body">
          <div class="modal-body-left">
            <div class="form-row">
              <div class="input-group">
                <label for="basic-url" style="font-size: 16px">{{ $t("uploadDatabase.chooseFile") }}</label>
                <div class="custom-file">
                  <label class="custom-file-label" for="inputGroupFile04" ref="fileLabel">{{
                    $t("uploadDatabase.chooseFile")
                  }}</label>
                  <input
                    type="file"
                    class="custom-file-input"
                    id="inputGroupFile04"
                    aria-describedby="inputGroupFileAddon04"
                    @change="updateFileName"
                    accept=".xlsx"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <label for="settingName" style="font-size: 16px">{{ $t("uploadDatabase.saveSettingsAs") }}</label>
              <div style="position: relative; flex: 1; min-width: 0">
                <input
                  type="text"
                  @change="checkCustomSettingName"
                  class="form-control"
                  :class="{ errorStyle: customSettingNameError }"
                  id="basic-url"
                  v-model="newCustomSetting.name"
                  :maxlength="20"
                  :placeholder="placeholder"
                  style="border-radius: 10px"
                  aria-describedby="basic-addon3"
                />
                <span class="counter" :class="{ errorCounter: customSettingNameCountError }"
                  >{{ newCustomSetting?.name?.length }}/20</span
                >
              </div>
            </div>
            <div class="tktTex form-row">
              <label for="basic-url" style="font-size: 16px">{{ $t("uploadDatabase.threadSize") }}</label>
              <div class="input-group mb-3">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="Tkt"
                    v-model="selectedTktTex"
                  />
                  <label class="form-check-label" for="inlineRadio1">{{ $t("addCustomSetting.tkt") }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value="Tex"
                    v-model="selectedTktTex"
                  />
                  <label class="form-check-label" for="inlineRadio2">{{ $t("addCustomSetting.tex") }}</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <label for="basic-url" style="font-size: 16px">{{ $t("uploadDatabase.language") }}</label>
              <div class="search row height d-flex align-items-center">
                <div class="stitchType" style="padding: 13px">
                  <ComboBox
                    ref="LanguageData"
                    :data-source="LanguageData"
                    :height="265"
                    :maxlength="30"
                    :filter="'contains'"
                    :placeholder="'Select Language'"
                    :style="{ width: '20em !important' }"
                    :data-text-field="'text'"
                    :data-value-field="'value'"
                    :value="selectedLanguage"
                    @change="validateLanguage($event.sender.value())"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <label for="basic-url" style="font-size: 16px">{{ $t("styleGrid.customer") }}</label>
              <div class="search row height d-flex align-items-center">
                <div class="stitchType" style="padding: 13px">
                  <ComboBox
                    :data-source="customers.length ? customers : []"
                    :data-text-field="'text'"
                    :data-value-field="'value'"
                    :height="275"
                    :maxlength="30"
                    :filter="'contains'"
                    :placeholder="'Select Customer'"
                    :value="customerVal"
                    :min-filter-length="0"
                    @change="validateCustomer($event.sender.text(), $event.sender.value())"
                    :style="{ width: '20em !important' }"
                    :required="true"
                  >
                  </ComboBox>
                </div>
              </div>
            </div>
            <div class="form-row">
              <button
                type="submit"
                class="btn btn-sm btn-primary submitButton"
                @click="onSubmit"
                :disabled="!canStartNewUpload"
                :class="{ 'btn-secondary': !canStartNewUpload }"
              >
                <span v-if="pollingInterval || isSubmitting">
                  <i class="fa fa-spinner fa-spin"></i> {{ uploadButtonText }}
                </span>
                <span v-else>
                  {{ uploadButtonText }}
                </span>
              </button>
            </div>
          </div>
          <div class="modal-body-right">
            <span>Status</span>
            <div style="margin-top: 10px; font-weight: bold; color: #0054a6">
              {{ statusMessage }}
            </div>
            <div v-if="showDownloadFailedButton" style="margin-top: 15px">
              <button
                type="button"
                class="btn btn-sm btn-warning"
                @click="downloadFailedRecords"
                :disabled="downloadingReport"
                style="border-radius: 5px"
              >
                <span v-if="downloadingReport"> <i class="fa fa-spinner fa-spin"></i> Downloading... </span>
                <span v-else> Download Failed Records </span>
              </button>
            </div>
            <div v-if="currentImportId && !pollingInterval" style="margin-top: 15px">
              <button
                v-if="!uploadCompleted && !uploadFailed"
                type="button"
                class="btn btn-sm btn-info"
                @click="manualStatusCheck"
                style="border-radius: 5px; margin-right: 10px"
              >
                Check Status
              </button>
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                @click="clearCurrentUpload"
                style="border-radius: 5px; margin-right: 10px"
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ComboBox } from "@progress/kendo-dropdowns-vue-wrapper";
import {
  CustomerApi,
  CustomerCreateDto,
  CustomSettingsApi,
  DataImportApi,
  UserCustomSettingDto,
  UserAdminSettingApi
} from "@/api";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import ListComponent from "./ListComponent.vue";
import AlertComponent from "./AlertComponent.vue";
import { AppModule } from "@/core/store/modules/app-module";
import { CDIdentityModule } from "@/core/store/modules/cd-identity-module";

export default defineComponent({
  name: "DBUploadPage",
  components: {
    ComboBox,
    ListComponent,
    AlertComponent
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  emits: ["closeModal"],
  setup() {
    const customSettingsApi = new CustomSettingsApi();
    const customerApi = new CustomerApi();
    const router = useRouter();
    const dataImportApi = new DataImportApi();
    const userAdminSettingApi = new UserAdminSettingApi();
    return { customSettingsApi, customerApi, router, dataImportApi, userAdminSettingApi };
  },
  data() {
    return {
      customSettingName: "",
      newCustomSetting: {
        id: 0,
        name: "",
        defaultAllowance: 10,
        tktTex: "Tkt"
      } as UserCustomSettingDto,
      customSettingNameError: false,
      customSettingNameCountError: false,
      customSettingNameEmptyError: false,
      placeholder: this.$t("addCustomSetting.settingNameShouldBeUnique") as any,
      LanguageData: [
        { text: "Default (English UK)", value: "English UK" },
        { text: "French", value: "French" },
        { text: "Spanish", value: "Spanish" },
        { text: "Portuguese", value: "Portuguese" },
        { text: "Turkish", value: "Turkish" }
      ],
      customers: [] as any,
      customerData: [] as any,
      customerVal: "",
      selectedCustomerId: 0,
      errorMsgCustomer: "",
      toast: useToast(),
      isCancelButtonClicked: false,
      visibleDialog: false,
      selectedTktTex: "Tkt",
      selectedLanguage: "English UK",
      selectedFile: null as File | null,
      statusMessage: "",
      fileStatus: "",
      showDownloadFailedButton: false,
      pollingInterval: null as number | null,
      currentImportId: null as number | null,
      downloadingReport: false,
      pollingStartTime: null as number | null,
      pollingCount: 0,
      STATUS: {
        PENDING: 1,
        PROCESSING: 2,
        COMPLETED: 3,
        FAILED: 4
      },
      messages: [] as Array<{ text: string; type: string }>,
      uploadCompleted: false,
      uploadFailed: false,
      isSubmitting: false,
      costFileName: ""
    };
  },
  computed: {
    oidcUser(): any {
      return (this as any).$store.getters.oidcUser;
    },
    currentUserId(): string | null {
      return this.oidcUser?.sub || this.oidcUser?.id || null;
    },
    currentTenantId(): string | null {
      return this.oidcUser?.cd_tenant_id || null;
    },
    currentUserName(): string | null {
      return (
        AppModule.config.currentUser?.name ||
        AppModule.config.currentUser?.userName ||
        this.oidcUser?.name ||
        this.oidcUser?.preferred_username ||
        null
      );
    },
    currentTenantName(): string | null {
      return (
        AppModule.config.currentTenant?.name ||
        CDIdentityModule.cdOrganisation?.name ||
        sessionStorage.getItem("TenantName") ||
        null
      );
    },
    isAuthenticated(): boolean {
      return !!this.oidcUser && !!this.currentUserId;
    },
    isFormValid(): boolean {
      const nameFilled = (this.newCustomSetting.name?.trim().length ?? 0) > 0;
      const customerFilled = (this.customerVal?.trim().length ?? 0) > 0;
      return (
        !!this.selectedFile &&
        nameFilled &&
        !this.customSettingNameCountError &&
        customerFilled &&
        !this.errorMsgCustomer &&
        !!this.selectedLanguage &&
        !!this.selectedTktTex
      );
    },
    canStartNewUpload(): boolean {
      return !this.pollingInterval && !this.isSubmitting && this.isFormValid;
    },
    uploadButtonText(): string {
      if (this.isSubmitting && !this.pollingInterval) {
        return "Uploading...";
      } else if (this.pollingInterval) {
        return "Processing...";
      } else {
        return "Upload/Process";
      }
    }
  },
  created() {
    this.getCustomerData();
    this.onMountAdminSettings();
  },
  mounted() {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    this.$nextTick(() => {
      this.checkPendingUploads();
    });
  },
  beforeUnmount() {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    this.stopPolling();
  },
  methods: {
    async onMountAdminSettings(): Promise<void> {
      await this.userAdminSettingApi
        .apiSystemConfigurationGet()
        .then(e => {
          this.costFileName = e.data.costFileName as string;
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
    },
    async getCustomerData(): Promise<void> {
      await this.customerApi
        .apiGetCustomersOrderByMostFrequentlyUsedGet()
        .then(res => {
          for (let customer of res.data) {
            this.customers.push({ text: customer.name, value: customer.id });
          }
          this.customerData = res.data;
        })
        .catch(() => {
          this.toast.error(this.$t("styleGrid.customerLoadFailed"), {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
    },
    focusInput() {
      this.$nextTick(() => {
        (this.$refs?.settingNameInput as any)?.focus();
      });
    },
    handleSetWindow() {
      this.isCancelButtonClicked = false;
      this.$emit("closeModal");
    },
    updateFileName(event: Event) {
      const target = event.target as HTMLInputElement;
      const files = target.files;
      if (files && files.length > 0) {
        const fileName = files[0].name;
        this.selectedFile = files[0];
        const label = this.$refs.fileLabel as HTMLElement;
        if (label) {
          label.textContent = fileName;
        }
        this.addMessage(this.$t("uploadDatabase.fileSelected", { fileName }) as string, "info");
      }
    },
    setCustomSettingName(value: string) {
      this.customSettingName = value;
    },
    async checkCustomSettingName(): Promise<void> {
      this.newCustomSetting.name = this.newCustomSetting.name?.trim();
      await this.customSettingsApi.apiIsCustomSettingExistByNameGet(this.newCustomSetting.name as string).then(res => {
        if (res.data) this.customSettingNameError = false;
        else this.customSettingNameError = true;
      });
      if (this.newCustomSetting.name!.length > 20) this.customSettingNameCountError = true;
      else this.customSettingNameCountError = false;
      if (this.newCustomSetting.name?.length == 0) this.customSettingNameEmptyError = true;
      else this.customSettingNameEmptyError = false;
    },
    validateLanguage(value: any) {
      this.selectedLanguage = value;
      const valid = this.LanguageData.some(lang => lang.value === value);
      if (!valid) {
        this.toast.error(this.$t("uploadDatabase.languageError") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
        this.selectedLanguage = "English UK";
      }
    },
    validateCustomer(customerName: string, customerId: number): void {
      this.customerVal = customerName;

      if (Number.isInteger(Number(customerId))) {
        this.selectedCustomerId = customerId;
      } else {
        this.selectedCustomerId = 0;
      }

      if (customerName == "" || customerName == undefined || customerName == null)
        this.errorMsgCustomer = this.$t("styleCreateComp.pleaseSelectTheCustomer") as string;
      else if (customerName.length > 30)
        this.errorMsgCustomer = this.$t("styleCreateComp.maximum30CharacterAreAllowed") as string;
      else this.errorMsgCustomer = "";

      if (this.errorMsgCustomer == "") {
        this.customerVal = customerName.trim();
      } else {
        this.toast.error(this.errorMsgCustomer, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    sanitizeFileName(fileName: string): string {
      return fileName
        .replace(/[\\/:?#[\]@!$&'()*+,;=%]/g, "_")
        .replace(/\s+/g, "_")
        .replace(/_{2,}/g, "_")
        .toLowerCase();
    },
    async onSubmit() {
      this.isSubmitting = true;
      try {
        if (this.costFileName == "") {
          this.toast.error(this.$t("uploadDatabase.costFileError") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          return;
        }

        if (this.pollingInterval) {
          this.toast.warning(this.$t("uploadDatabase.uploadProcessing") as string, {
            toastClassName: "custom-warning-toast",
            timeout: 5000
          });
          return;
        }

        if (!this.currentTenantId) {
          this.toast.error(this.$t("uploadDatabase.uploadFailed") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          this.addMessage(this.$t("uploadDatabase.uploadFailed") as string, "error");
          return;
        }

        this.currentImportId = null;
        this.showDownloadFailedButton = false;
        this.downloadingReport = false;
        this.pollingStartTime = null;
        this.pollingCount = 0;
        this.uploadCompleted = false;
        this.uploadFailed = false;
        this.statusMessage = "";

        if (this.selectedCustomerId == 0) {
          const newCustomerVal = { name: this.customerVal } as CustomerCreateDto;
          await this.customerApi.apiCustomerPost(newCustomerVal).then(res => {
            this.selectedCustomerId = res.data.id as number;
          });
          await this.getCustomerData();
        }
        if (!this.selectedFile) {
          this.toast.error(this.$t("uploadDatabase.selectFileToUpload") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          return;
        }

        await this.checkCustomSettingName();

        if (
          !this.customSettingNameError &&
          !this.customSettingNameCountError &&
          !this.customSettingNameEmptyError &&
          !this.errorMsgCustomer
        ) {
          await this.dataImportApi
            .apiImportApiUploadDBPost(
              this.selectedLanguage,
              this.selectedCustomerId,
              undefined,
              this.newCustomSetting.name as string,
              this.selectedTktTex,
              this.selectedFile as File
            )
            .then(response => {
              let importId = null;
              if (response.data != null) {
                const responseData = response.data as any;
                if (responseData.success === false) {
                  const failMsg = responseData.message || (this.$t("uploadDatabase.uploadFailed") as string);
                  this.toast.error(failMsg, {
                    toastClassName: "custom-error-toast",
                    timeout: 5000
                  });
                  this.addMessage(failMsg, "error");
                  return;
                }
                importId = responseData.fileImportId || responseData.id || responseData.importId;
              }

              if (importId) {
                this.currentImportId = Number(importId);
                this.addMessage(this.$t("uploadDatabase.fileUploadedSuccessfully") as string, "info");
                this.startPolling(String(importId));
              } else {
                this.toast.success(this.$t("uploadDatabase.fileProcessedSuccessfully") as string, {
                  toastClassName: "custom-success-toast",
                  timeout: 5000
                });
                this.addMessage(this.$t("uploadDatabase.fileProcessedSuccessfully") as string, "success");
              }
            })
            .catch(error => {
              this.addMessage(this.$t("uploadDatabase.uploadFailed") as string, "error");
              throw error;
            });
        } else if (this.customSettingNameEmptyError) {
          this.toast.error(this.$t("addCustomSetting.enterSettingName") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        } else {
          this.toast.error(this.$t("addCustomSetting.eitherDuplicateOrExtendedSettingName") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        }
      } catch (error) {
        const errorMsg = error instanceof Error ? error.message : (this.$t("uploadDatabase.errorOccured") as string);
        this.addMessage(errorMsg, "error");
        this.toast.error(errorMsg, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    addMessage(text: string, type: string) {
      this.messages.push({ text, type });
      this.statusMessage = text;
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
      this.pollingStartTime = null;
      this.pollingCount = 0;
    },
    startPolling(fileImportId: string) {
      this.stopPolling();

      this.pollingStartTime = Date.now();
      this.pollingCount = 0;

      this.pollingInterval = setInterval(() => {
        this.pollingCount++;
        this.checkFileStatus(fileImportId);
      }, 5000);

      setTimeout(() => {
        if (this.pollingInterval) {
          this.stopPolling();
          this.addMessage(this.$t("uploadDatabase.processingTimedOut") as string, "warning");
        }
      }, 900000);
    },
    async downloadFailedRecords() {
      if (!this.currentImportId) {
        this.toast.error(this.$t("uploadDatabase.noImportIdAvailable") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
        return;
      }

      if (this.downloadingReport) {
        return;
      }

      this.downloadingReport = true;

      try {
        const response = (await this.dataImportApi.apiImportDownloadFailedRecordsFileImportIdGet(this.currentImportId, {
          responseType: "blob"
        } as any)) as any;
        const responseData = response.data as Blob;
        if (!responseData || responseData.size === 0) {
          throw new Error("No file data received from server");
        }

        const blob = new Blob([responseData], {
          type: response.headers["content-type"] || "text/csv"
        });

        const url = globalThis.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const contentDisposition = response.headers["content-disposition"];
        let fileName = `failed_records_${new Date().toISOString().split("T")[0]}.csv`;

        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/["']/g, "");
          }
        }

        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(url);

        this.toast.success(this.$t("uploadDatabase.downloadedFailedReport", { fileName }) as string, {
          toastClassName: "custom-success-toast",
          timeout: 5000
        });
      } catch (error) {
        let errorMessage = this.$t("uploadDatabase.downloadFailedForFailedRecords") as string;

        if (error instanceof Error) {
          errorMessage += `: ${error.message}`;
        }

        this.toast.error(errorMessage, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } finally {
        this.downloadingReport = false;
      }
    },
    async manualStatusCheck() {
      if (!this.currentImportId) {
        this.toast.error(this.$t("uploadDatabase.noImportIdAvailable") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
        return;
      }

      this.addMessage(this.$t("uploadDatabase.checkStatus") as string, "info");

      try {
        await this.checkFileStatus(String(this.currentImportId));
        if (this.statusMessage === this.$t("uploadDatabase.checkStatus")) {
          this.addMessage(this.$t("uploadDatabase.statusCheckCompleted") as string, "warning");
        }
      } catch (error) {
        const errorMsg = error instanceof Error ? error.message : (this.$t("uploadDatabase.errorOccured") as string);
        this.addMessage(errorMsg, "error");
        this.toast.error(errorMsg, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    async checkPendingUploads() {
      try {
        const response = (await this.dataImportApi.apiImportGetLatestUploadedDBGet()) as any;
        const latestImport = response?.data;
        if (!latestImport || !latestImport.id) {
          return;
        }

        this.currentImportId = latestImport.id;
        this.pollingStartTime = latestImport.startTime ? new Date(latestImport.startTime).getTime() : Date.now();

        const status = latestImport.status;

        if (status === this.STATUS.PROCESSING || status === this.STATUS.PENDING) {
          this.addMessage(this.$t("uploadDatabase.resumedTrackingImport") as string, "info");
          this.startPolling(String(this.currentImportId));
        } else if (status === this.STATUS.COMPLETED) {
          this.handlePreviousCompletedImport(latestImport);
        } else if (status === this.STATUS.FAILED) {
          this.uploadFailed = true;
          const errorMsg = latestImport.errorMessage || (this.$t("uploadDatabase.errorOccured") as string);
          this.addMessage(this.$t("uploadDatabase.previousImportFailed", { errorMsg }) as string, "error");
        }
      } catch (error) {
        const errorMsg = error instanceof Error ? error.message : (this.$t("uploadDatabase.errorOccured") as string);
        this.addMessage(this.$t("uploadDatabase.failedToFetch") as string, "error");
        this.toast.error(errorMsg, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    handlePreviousCompletedImport(latestImport: any) {
      this.uploadCompleted = true;
      let progressInfo: any = null;
      if (latestImport.errorMessage) {
        try {
          progressInfo = JSON.parse(latestImport.errorMessage);
        } catch {
          /* non-JSON */
        }
      }
      if (progressInfo && progressInfo.failed_records > 0) {
        this.showDownloadFailedButton = true;
        this.addMessage(
          this.$t("uploadDatabase.previousImportCompletedWithIssues", {
            successful: progressInfo.successful_records,
            total: progressInfo.total_records,
            failed: progressInfo.failed_records
          }) as string,
          "warning"
        );
      } else {
        this.addMessage(this.$t("uploadDatabase.importCompletedSuccessfully") as string, "success");
      }
    },
    clearCurrentUpload() {
      this.stopPolling();
      this.currentImportId = null;
      this.showDownloadFailedButton = false;
      this.statusMessage = "";
      this.messages = [];
      this.uploadCompleted = false;
      this.uploadFailed = false;
      this.toast.info(this.$t("uploadDatabase.uploadStatusCleared") as string, {
        toastClassName: "custom-info-toast",
        timeout: 3000
      });
    },
    async checkFileStatus(fileImportId: string) {
      try {
        if (!this.currentImportId) {
          this.currentImportId = Number.parseInt(fileImportId);
        }

        let progress: any;

        try {
          const importId = Number.parseInt(fileImportId);
          const response = await this.dataImportApi.apiImportProgressFileImportIdGet?.(importId);
          progress = response?.data;
        } catch (error) {
          this.addMessage(this.$t("uploadDatabase.failedToFetch") as string, "error");
          throw error;
        }

        if (!progress) {
          throw new Error("No progress data received");
        }

        this.fileStatus = progress.status || "";

        let progressInfo: any = null;
        if (progress.errorMessage) {
          try {
            progressInfo = JSON.parse(progress.errorMessage);
          } catch {
            progressInfo = { message: progress.errorMessage };
          }
        }
        switch (Number(progress.status)) {
          case this.STATUS.PROCESSING: {
            const elapsedMinutes = this.pollingStartTime ? Math.floor((Date.now() - this.pollingStartTime) / 60000) : 0;
            const processingMsg =
              elapsedMinutes > 0
                ? (this.$t("uploadDatabase.processingFileElapsed", { elapsedMinutes }) as string)
                : (this.$t("uploadDatabase.processing") as string);
            this.addMessage(processingMsg, "info");
            break;
          }
          case this.STATUS.COMPLETED:
            this.stopPolling();
            this.uploadCompleted = true;
            this.uploadFailed = false;
            this.handleCompletedFileStatus(progressInfo);
            this.toast.success(this.$t("uploadDatabase.importCompletedSuccessfully") as string, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
            break;
          case this.STATUS.FAILED: {
            this.stopPolling();
            this.uploadCompleted = false;
            this.uploadFailed = true;

            const errorMsg = progress.errorMessage || (this.$t("uploadDatabase.errorOccured") as string);
            const failureMessage = this.$t("uploadDatabase.importFailed", { errorMsg }) as string;
            this.addMessage(failureMessage, "error");

            this.toast.error(this.$t("uploadDatabase.importFailed", { errorMsg }) as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
            break;
          }
          case this.STATUS.PENDING:
            this.addMessage(this.$t("uploadDatabase.processing") as string, "info");
            break;
          default:
            this.addMessage(this.$t("uploadDatabase.unknowStatus", { status: progress.status }) as string, "warning");
            break;
        }
      } catch {
        this.addMessage(this.$t("uploadDatabase.failedToFetch") as string, "error");
        this.stopPolling();
      }
    },
    handleCompletedFileStatus(progressInfo: any) {
      if (progressInfo && progressInfo.failed_records > 0) {
        this.showDownloadFailedButton = true;
        this.addMessage(
          this.$t("uploadDatabase.importCompletedWithIssues", {
            successful: progressInfo.successful_records,
            total: progressInfo.total_records,
            failed: progressInfo.failed_records
          }) as string,
          "warning"
        );
      } else if (progressInfo && progressInfo.message) {
        this.addMessage(progressInfo.message, "success");
      } else {
        this.addMessage(this.$t("uploadDatabase.importCompletedSuccessfully") as string, "success");
      }
    }
  }
});
</script>

<style scoped>
.modal-header {
  background-color: #0054a6;
  color: white;
  padding: 0.75rem;
  height: auto;
  border-top-left-radius: 0 !important;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 12001 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-fullscreen {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  background: #fff;
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
}
.modal-close {
  position: absolute;
  top: 12px;
  right: 24px;
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  z-index: 2;
  color: #fff;
}
.modal-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  margin-top: 0.75rem;
  color: black;
  justify-content: center;
}
.modal-body-left {
  flex: 3;
  padding: 20px 20px 20px 20px;
  border-right: 1px solid #ddd;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal-body-right {
  flex: 1;
  padding: 20px;
}
.form-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 1.5rem;
  width: 100%;
  max-width: 700px;
  flex-wrap: nowrap;
}
.form-row label {
  min-width: 200px;
  font-weight: 500;
  text-align: left;
  flex-shrink: 0;
}
.form-row .input-group,
.form-row .search {
  flex: 1;
  min-width: 0;
}
.form-row .input-group > label {
  flex: 0 0 200px;
  max-width: 200px;
  font-weight: 500;
  text-align: left;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  align-self: center;
  margin-bottom: 0;
}
input[type="radio"].form-check-input:checked {
  background-color: #ffffff;
  border-color: #858585;
  background-image: radial-gradient(circle at center, #858585 50%, transparent 40%);
}
.form-check-input {
  border-color: #484747;
  box-shadow: 0 0 0 0.25rem rgba(255, 255, 255, 0.75) !important;
}
.tktTex.form-row {
  flex-wrap: nowrap;
}
.tktTex.form-row label {
  min-width: 200px;
  text-align: left;
  flex-shrink: 0;
}
.tktTex .input-group.mb-3 {
  display: flex;
  align-items: center;
  gap: 15px !important;
  margin-bottom: 0;
  flex-wrap: nowrap;
  width: auto;
}
.tktTex .form-check.form-check-inline {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  white-space: nowrap;
  flex-shrink: 0;
}
.tktTex .form-check-label {
  margin-left: 5px;
  font-size: 14px;
  white-space: nowrap;
}
.submitButton {
  margin-left: 200px;
  width: auto;
  border-radius: 5px;
  background-color: #0054a6;
  color: white;
  padding: 8px;
}
.custom-file {
  margin-left: 20px !important;
  cursor: pointer !important;
}
.custom-file-input {
  cursor: pointer !important;
}
.custom-file-label:after {
  cursor: pointer !important;
}

.form-row input[type="text"] {
  position: relative;
  padding-right: 40px;
}

.counter {
  position: absolute;
  top: 80%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 2;
  font-size: 13px;
  color: #888;
  pointer-events: none;
}

.alert {
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
.btn-secondary {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  cursor: not-allowed;
}
.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
